<template>
  <div class="page page-notifications content">
    <h1 class="page__title">{{ str('notifications.title') }}</h1>
    <div class="notifications__actions">
      <div
        for="toggle-unread-notifications"
        class="notifications__filter"
        @click="showUnread = !showUnread"
      >
        <JsToggle
          :value="showUnread"
          :height="25"
          :sync="true"
          id="toggle-unread-notifications"
          @change="toggleUnread()"
          ref="toggleReadNotifications"
        ></JsToggle>
        {{ str('notifications.toggleUnread') }}
      </div>
      <button
        v-if="hasUnreadNotifications"
        class="button button--secondary"
        @click="markAllAsRead"
      >
        {{ str('notifications.markAllAsRead') }}
      </button>
    </div>
    <ul class="notifications__list">
      <li
        v-for="notification in notifications.slice(0, maxNotifications)"
        :key="notification.id"
        class="notifications__list-item"
      >
        <Notification :notification="notification" />
      </li>
    </ul>
    <button
      class="button button--secondary notifications__more"
      @click="maxNotifications += showMoreSteps"
      v-if="showMoreLink()"
    >
      {{ str('notifications.showMore') }}
    </button>
  </div>
</template>

<script>
  import Notification from '@/components/Notification'
  import { ToggleButton as JsToggle } from 'vue-js-toggle-button'

  export default {
    name: 'page-notifications',
    components: {
      Notification,
      JsToggle,
    },
    data() {
      return {
        showUnread: false,
        maxNotifications: 10,
        showMoreSteps: 10,
      }
    },
    computed: {
      rawNotifications() {
        return this.$store.getters.notifications
      },
      hasUnreadNotifications() {
        return (
          this.$store.getters.notifications.filter(
            (notification) => notification.unread === 1
          ).length > 0
        )
      },
      notifications() {
        return this.$store.getters.notifications.filter((n) => {
          if (this.showUnread) {
            return true
          }
          return n.unread === 1
        })
      },
    },
    methods: {
      toggleUnread() {
        this.showUnread = !this.showUnread
      },
      markAllAsRead() {
        this.$store.dispatch('markNotificationsAsRead', {
          all: true,
        })
      },
      showMoreLink() {
        return this.notifications.length > this.maxNotifications
      },
    },
    watch: {
      rawNotifications() {},
    },
  }
</script>

<style lang="scss" scoped>
  .page-notifications {
    max-width: $content-page-width;
  }

  .notifications {
    &__headline {
      margin: spacer(4) 0 spacer(1);
      font-size: $font-size-lg;
      font-weight: bold;
    }

    &__actions {
      display: flex;
      justify-content: space-between;
      margin-bottom: spacer(3);
    }

    &__filters {
      padding: 0 spacer(3);
      margin-bottom: spacer(0.5);
    }

    &__filter {
      display: inline-flex;
      align-items: center;
      justify-content: space-between;

      label {
        margin-right: spacer(0.75);
      }
    }

    &__list {
      margin: spacer(1) 0;
      padding: 0;
      list-style: none;

      &-item {
        transition: $transition-base;
        $offset: spacer(1);
        margin-left: $offset * -1;
        margin-right: $offset * -1;
        padding-left: $offset;
        padding-right: $offset;
        padding-bottom: spacer(0.5);
        padding-top: spacer(0.5);
        border-bottom: 1px solid $grey-light;

        &:last-child {
          border-bottom: none;
        }

        &:hover,
        &:active,
        &:focus {
          background: $grey-lightest;
        }
      }
    }

    &__more {
      display: block;
      margin: spacer(0.25) auto spacer(2);
      max-width: 300px;
    }
  }
</style>
